/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocker = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-docker_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-docker_svg__st0"
      d="M8 14h2v5H8zm6-9h2v5h-2zM8 5h2v5H8zm-3 9h2v5H5zm0-9h2v5H5z"
    />
    <path
      className="ico-docker_svg__st0"
      d="M2 2v20h20V2H2zm9 18H4v-7h7v7zm0-9H4V4h7v7zm9 9h-7v-7h7v7zm0-9h-7V4h7v7z"
    />
    <path className="ico-docker_svg__st0" d="M17 5h2v5h-2zm-3 9h2v5h-2zm3 0h2v5h-2z" />
  </Icon>
);
export { SvgDocker as Docker };
